// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GitlabFilledSvg from "@fishx/icons-svg/es/asn/GitlabFilled";
import FishxIcon from '../components/FishxIcon';

var GitlabFilled = function GitlabFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GitlabFilledSvg
  }));
};

GitlabFilled.displayName = 'GitlabFilled';
export default React.forwardRef(GitlabFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GitlabFilled.js
// module id = 2871
// module chunks = 0